import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/plat/admin/track/data/"

function baseApi() {

    function deleteData(data) {
        return Post(baseUrl + "deleteTrackData", data)
    }

    function update(data) {
        return Post(baseUrl + "updateTrackData", data)
    }

    function query(data) {
        return Post(baseUrl + "queryTrackData", data)
    }

    return {
        query,
        update,
        deleteData
    }
}

export const trackDataApi = baseApi()